import React from "react";
import {PopoverMenuMoreProps} from "../../../../../generic/dropdown/components/popover/popover-menu-more";
import Task from "../../../../../../model2/task/task";
import ACLProject from "../../../../../../gd/access-control/project/project";

export default function FieldTaskType_PopoverMore(props:PopoverMenuMoreProps) {


    const task: Task = props.model as Task

    if (!task || !task.projectId) return null

    if (!ACLProject.hasFullAccess(task.projectId)) return null

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        props.parent.hidePopover();
        gd.navigation.goToProject(task.projectId, '/info/settings/task-types')
    }

    return (
        <div className="help">
            <div className="flex-row-left-center" onClick={onClick}>
                <div className="ui5-ico-15 i5-wrench m-r-8" />
                <div className="ui5-txt-link-small-no-accent" >Edit task types</div>
            </div>
        </div>

    );
}
